import React, { useState, useEffect } from 'react';
import { FiTrash2, FiSend, FiSearch, FiDownload, FiExternalLink, FiGrid } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { useApi } from '../hooks/useApi';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import { useNotifications } from '../context/NotificationContext';
import SearchSelect from '../components/SearchSelect/SearchSelect';
import Modal from '../components/Modal/Modal';
import CatalogJsonViewer from '../components/CatalogJsonViewer/CatalogJsonViewer';
import Translate from './Translate';
import { API_BASE_URL } from '../config';
import p from './Pages.module.css';

const MARGIN_FIELDS = [
  { key: 'margin1x2', label: '1x2' }, { key: 'marginDoubleChance', label: 'Double Chance' },
  { key: 'marginFirstGoal', label: 'First Goal' }, { key: 'marginOu25', label: 'O/U 2.5' },
  { key: 'marginOu35', label: 'O/U 3.5' }, { key: 'marginOu45', label: 'O/U 4.5' },
  { key: 'marginOu55', label: 'O/U 5.5' }, { key: 'marginOu65', label: 'O/U 6.5' },
  { key: 'marginEh10', label: 'EH 1:0' }, { key: 'marginEh01', label: 'EH 0:1' },
  { key: 'marginHt1x2', label: 'HT 1x2' }, { key: 'marginHtDoubleChance', label: 'HT DC' },
  { key: 'marginHtOu05', label: 'HT O/U 0.5' }, { key: 'marginHtOu15', label: 'HT O/U 1.5' },
  { key: 'marginHtOu25', label: 'HT O/U 2.5' }, { key: 'marginHtEh10', label: 'HT EH 1:0' },
  { key: 'marginHtEh01', label: 'HT EH 0:1' }, { key: 'marginHtBtts', label: 'HT BTTS' },
  // 2nd Half
  { key: 'marginSh1x2', label: '2H 1x2' }, { key: 'marginShDoubleChance', label: '2H DC' },
  { key: 'marginShOu05', label: '2H O/U 0.5' }, { key: 'marginShOu15', label: '2H O/U 1.5' },
  { key: 'marginShOu25', label: '2H O/U 2.5' }, { key: 'marginShEh10', label: '2H EH 1:0' },
  { key: 'marginShEh01', label: '2H EH 0:1' }, { key: 'marginShBtts', label: '2H BTTS' },
  // Special
  { key: 'marginHsh', label: 'HSH' }, { key: 'marginWtn', label: 'Win to Nil' }, { key: 'marginDnb', label: 'DNB' },
  // Corners FT
  { key: 'marginCornersFt1x2', label: 'Corners FT 1x2' }, { key: 'marginCornersFtDoubleChance', label: 'Corners FT DC' },
  { key: 'marginCornersFtOu1', label: 'Corners FT O/U 1' }, { key: 'marginCornersFtOu2', label: 'Corners FT O/U 2' }, { key: 'marginCornersFtOu3', label: 'Corners FT O/U 3' },
  { key: 'marginCornersFtEh10', label: 'Corners FT EH 1:0' }, { key: 'marginCornersFtEh01', label: 'Corners FT EH 0:1' }, { key: 'marginCornersFtEt', label: 'Corners FT ET' },
  // Corners 1H
  { key: 'marginCornersHt1x2', label: 'Corners 1H 1x2' }, { key: 'marginCornersHtDoubleChance', label: 'Corners 1H DC' },
  { key: 'marginCornersHtOu1', label: 'Corners 1H O/U 1' }, { key: 'marginCornersHtOu2', label: 'Corners 1H O/U 2' }, { key: 'marginCornersHtOu3', label: 'Corners 1H O/U 3' },
  { key: 'marginCornersHtEh10', label: 'Corners 1H EH 1:0' }, { key: 'marginCornersHtEh01', label: 'Corners 1H EH 0:1' }, { key: 'marginCornersHtBt', label: 'Corners 1H BT' },
  // YC FT
  { key: 'marginYcFt1x2', label: 'YC FT 1x2' }, { key: 'marginYcFtDoubleChance', label: 'YC FT DC' },
  { key: 'marginYcFtOu1', label: 'YC FT O/U 1' }, { key: 'marginYcFtOu2', label: 'YC FT O/U 2' }, { key: 'marginYcFtOu3', label: 'YC FT O/U 3' },
  { key: 'marginYcFtEh10', label: 'YC FT EH 1:0' }, { key: 'marginYcFtEh01', label: 'YC FT EH 0:1' }, { key: 'marginYcFtEt', label: 'YC FT ET' },
  // YC 1H
  { key: 'marginYcHt1x2', label: 'YC 1H 1x2' }, { key: 'marginYcHtDoubleChance', label: 'YC 1H DC' },
  { key: 'marginYcHtOu1', label: 'YC 1H O/U 1' }, { key: 'marginYcHtOu2', label: 'YC 1H O/U 2' }, { key: 'marginYcHtOu3', label: 'YC 1H O/U 3' },
  { key: 'marginYcHtEh10', label: 'YC 1H EH 1:0' }, { key: 'marginYcHtEh01', label: 'YC 1H EH 0:1' }, { key: 'marginYcHtEt', label: 'YC 1H ET' },
  // SOT FT
  { key: 'marginSotFt1x2', label: 'SOT FT 1x2' }, { key: 'marginSotFtDoubleChance', label: 'SOT FT DC' },
  { key: 'marginSotFtOu1', label: 'SOT FT O/U 1' }, { key: 'marginSotFtOu2', label: 'SOT FT O/U 2' }, { key: 'marginSotFtOu3', label: 'SOT FT O/U 3' },
  { key: 'marginSotFtEh10', label: 'SOT FT EH 1:0' }, { key: 'marginSotFtEh01', label: 'SOT FT EH 0:1' }, { key: 'marginSotFtEt', label: 'SOT FT ET' },
  // SOT 1H
  { key: 'marginSotHt1x2', label: 'SOT 1H 1x2' }, { key: 'marginSotHtDoubleChance', label: 'SOT 1H DC' },
  { key: 'marginSotHtOu1', label: 'SOT 1H O/U 1' }, { key: 'marginSotHtOu2', label: 'SOT 1H O/U 2' }, { key: 'marginSotHtOu3', label: 'SOT 1H O/U 3' },
  { key: 'marginSotHtEh10', label: 'SOT 1H EH 1:0' }, { key: 'marginSotHtEh01', label: 'SOT 1H EH 0:1' }, { key: 'marginSotHtBt', label: 'SOT 1H BT' },
];

const LAMBDA_FIELDS = [
  { key: 'lambdaHome', label: 'λ Home' }, { key: 'lambdaAway', label: 'λ Away' }, { key: 'lambdaTotal', label: 'λ Total' },
  { key: 'lambdaHomeHt', label: 'λ Home HT' }, { key: 'lambdaAwayHt', label: 'λ Away HT' },
  { key: 'lambdaHomeSh', label: 'λ Home 2H' }, { key: 'lambdaAwaySh', label: 'λ Away 2H' },
  { key: 'lambdaHomeCorners', label: 'λ Home Corners' }, { key: 'lambdaAwayCorners', label: 'λ Away Corners' },
  { key: 'lambdaHomeHtCorners', label: 'λ Home HT Corners' }, { key: 'lambdaAwayHtCorners', label: 'λ Away HT Corners' },
  { key: 'lambdaHomeYc', label: 'λ Home YC' }, { key: 'lambdaAwayYc', label: 'λ Away YC' },
  { key: 'lambdaHomeHtYc', label: 'λ Home HT YC' }, { key: 'lambdaAwayHtYc', label: 'λ Away HT YC' },
  { key: 'lambdaHomeSot', label: 'λ Home SOT' }, { key: 'lambdaAwaySot', label: 'λ Away SOT' },
  { key: 'lambdaHomeHtSot', label: 'λ Home HT SOT' }, { key: 'lambdaAwayHtSot', label: 'λ Away HT SOT' },
];

const SECTIONS = [
  { key: 'general', label: 'General', icon: '⚙️' },
  { key: 'notifications', label: 'Notifications', icon: '🔔' },
  { key: 'integrations', label: 'Integrations', icon: '🔗' },
  { key: 'lambda', label: 'Lambda Config', icon: '🔧' },
  { key: 'margins', label: 'Default Margins', icon: '📊' },
  { key: 'entities', label: 'Create Entities', icon: '➕' },
  { key: 'translation', label: 'Translation', icon: '🌐' },
  { key: 'imports', label: 'Imports', icon: '📥' },
  { key: 'catalog', label: 'Markets Catalog', icon: '📖' },
];

// Sub-sections under "Imports" — add new entries here when more imports are introduced.
const IMPORT_SUBSECTIONS = [
  { key: 'clubs', label: 'Clubs / Leagues / Countries', icon: '🏟️' },
];

export default function Settings() {
  const api = useApi();
  const { token } = useAuth();
  const toast = useToast();
  const [activeSection, setActiveSection] = useState('general');
  const [activeImport, setActiveImport] = useState(IMPORT_SUBSECTIONS[0].key);

  // Lambda
  const [lambda, setLambda] = useState(() => Object.fromEntries(LAMBDA_FIELDS.map(f => [f.key, ''])));

  // Margins
  const [marginsId, setMarginsId] = useState(null);
  const [margins, setMargins] = useState({});

  // Create entities — searchable, creatable, deletable dropdowns.
  // Selected `value` is the entity id so we can DELETE / PUT against /v1/<entity>/<id>.
  const [countries, setCountries] = useState([]);
  const [leagues, setLeagues] = useState([]);
  const [clubs, setClubs] = useState([]);
  const [countriesFetched, setCountriesFetched] = useState(false);
  const [leaguesFetched, setLeaguesFetched] = useState(false);
  const [clubsFetched, setClubsFetched] = useState(false);
  const [selectedCountryId, setSelectedCountryId] = useState('');
  const [selectedLeagueId, setSelectedLeagueId] = useState('');
  const [selectedClubId, setSelectedClubId] = useState('');
  // For new league: which country FK to attach (selected via name on backend).
  const [leagueCountryId, setLeagueCountryId] = useState('');

  // Integrations
  const INT_BASE = '/v1/clasico-integrations';
  const [intList, setIntList] = useState([]);
  const [intCode, setIntCode] = useState(''); const [intName, setIntName] = useState('');
  // Outbound webhook config on create.
  const [intOutboundEnabled, setIntOutboundEnabled] = useState(false);
  const [intOutboundBaseUrl, setIntOutboundBaseUrl] = useState('');
  const [intOutboundSecret, setIntOutboundSecret] = useState('');
  const [selInt, setSelInt] = useState(null); // selected integration for editing
  const [intMargins, setIntMargins] = useState({});
  const [intLambdas, setIntLambdas] = useState({});
  const [intEditName, setIntEditName] = useState(''); const [intEditCode, setIntEditCode] = useState(''); const [intEditActive, setIntEditActive] = useState(true);
  // Outbound webhook config on edit. `intEditOutboundSecret` stays empty
  // unless the admin types a new one (the server never returns the
  // current secret — it's write-only).
  const [intEditOutboundEnabled, setIntEditOutboundEnabled] = useState(false);
  const [intEditOutboundBaseUrl, setIntEditOutboundBaseUrl] = useState('');
  const [intEditOutboundSecret, setIntEditOutboundSecret] = useState('');

  // Notifications
  const { createNotification, getAllNotifications, deleteNotification, getNotificationTypes, getTargetTypes } = useNotifications();
  const [notifTypes, setNotifTypes] = useState([]);
  const [notifTargetTypes, setNotifTargetTypes] = useState([]);
  const [allNotifs, setAllNotifs] = useState([]);
  const [notifSearch, setNotifSearch] = useState('');
  // Create form
  const [nTitle, setNTitle] = useState('');
  const [nBody, setNBody] = useState('');
  const [nTypeId, setNTypeId] = useState('');
  const [nTargetTypeId, setNTargetTypeId] = useState('');
  const [nTargetUserId, setNTargetUserId] = useState('');
  const [nPriority, setNPriority] = useState('normal');
  const [nActionUrl, setNActionUrl] = useState('');
  const [nScheduledAt, setNScheduledAt] = useState('');
  const [nScheduledTz, setNScheduledTz] = useState('+01:00');
  // Users for target picker
  const [userList, setUserList] = useState([]);
  const [usersFetched, setUsersFetched] = useState(false);

  useEffect(() => {
    Promise.all([api.get('/v1/default-margins/'), api.get('/v1/lambda-config/')]).then(([m, l]) => {
      if (m) { const { id, ...rest } = m; setMarginsId(id); setMargins(rest); }
      if (l) setLambda(Object.fromEntries(LAMBDA_FIELDS.map(f => [f.key, l[f.key] ?? ''])));
    }).catch(() => {});
    loadIntegrations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadIntegrations = async () => {
    try {
      const r = await api.get(`${INT_BASE}/`);
      setIntList(Array.isArray(r) ? r : (r?.items || []));
    } catch {}
  };

  const loadNotifications = async () => {
    try {
      const data = await getAllNotifications();
      setAllNotifs(Array.isArray(data) ? data : []);
    } catch {}
  };

  const loadNotifLookups = async () => {
    try {
      const [types, targets] = await Promise.all([getNotificationTypes(), getTargetTypes()]);
      setNotifTypes(Array.isArray(types) ? types : []);
      setNotifTargetTypes(Array.isArray(targets) ? targets : []);
      // Default selection
      if (types?.length > 0 && !nTypeId) setNTypeId(types[0].id);
      if (targets?.length > 0 && !nTargetTypeId) setNTargetTypeId(targets[0].id);
    } catch {}
  };

  const fetchUsers = async () => {
    if (usersFetched) return;
    try { const d = await api.get('/v1/user/'); setUserList(Array.isArray(d) ? d : (d?.items || [])); setUsersFetched(true); } catch {}
  };

  const handleCreateNotification = async () => {
    if (!nTitle.trim()) { toast.error('Title is required'); return; }
    if (!nTypeId) { toast.error('Select a notification type'); return; }
    if (!nTargetTypeId) { toast.error('Select a target type'); return; }
    const targetType = notifTargetTypes.find(t => t.id === Number(nTargetTypeId));
    if (targetType?.code === 'user' && !nTargetUserId) { toast.error('Select a target user'); return; }
    const payload = {
      title: nTitle.trim(),
      body: nBody.trim() || undefined,
      notificationTypeId: Number(nTypeId),
      targetTypeId: Number(nTargetTypeId),
      targetUserId: targetType?.code === 'user' ? Number(nTargetUserId) : undefined,
      priority: nPriority,
      actionUrl: nActionUrl.trim() || undefined,
      scheduledAt: nScheduledAt ? `${nScheduledAt}:00${nScheduledTz}` : undefined,
    };
    try {
      await createNotification(payload);
      toast.success('Notification created');
      setNTitle(''); setNBody(''); setNActionUrl(''); setNScheduledAt(''); setNTargetUserId('');
      loadNotifications();
    } catch (e) { toast.error(e.message); }
  };

  const handleDeleteNotification = async (id) => {
    try {
      await deleteNotification(id);
      toast.success('Notification deleted');
      setAllNotifs(prev => prev.filter(n => n.id !== id));
    } catch (e) { toast.error(e.message); }
  };

  const createIntegration = async () => {
    if (!intCode.trim()) { toast.error('Code is required'); return; }
    if (intOutboundEnabled && !intOutboundBaseUrl.trim()) {
      toast.error('Outbound base URL is required when outbound is enabled');
      return;
    }
    try {
      const body = {
        code: intCode,
        name: intName || intCode,
        outboundEnabled: !!intOutboundEnabled,
        outboundBaseUrl: intOutboundBaseUrl.trim() || null,
      };
      if (intOutboundSecret.trim()) body.outboundSecret = intOutboundSecret;
      await api.post(`${INT_BASE}/`, body);
      toast.success('Integration created');
      setIntCode(''); setIntName('');
      setIntOutboundEnabled(false); setIntOutboundBaseUrl(''); setIntOutboundSecret('');
      await loadIntegrations();
    } catch (e) { toast.error(e.message); }
  };

  const selectIntegration = async (int) => {
    setSelInt(int);
    setIntEditName(int.name || ''); setIntEditCode(int.code || ''); setIntEditActive(int.active !== false);
    setIntEditOutboundEnabled(!!int.outboundEnabled);
    setIntEditOutboundBaseUrl(int.outboundBaseUrl || '');
    setIntEditOutboundSecret('');
    // Load margins + lambdas
    try {
      const [m, l] = await Promise.all([api.get(`${INT_BASE}/${int.id}/margins`), api.get(`${INT_BASE}/${int.id}/lambdas`)]);
      if (m) { const { id, ...rest } = m; setIntMargins(rest); } else setIntMargins({});
      if (l) { const { id, ...rest } = l; setIntLambdas(rest); } else setIntLambdas({});
    } catch { setIntMargins({}); setIntLambdas({}); }
  };

  const updateIntegration = async () => {
    if (!selInt) return;
    if (intEditOutboundEnabled && !intEditOutboundBaseUrl.trim()) {
      toast.error('Outbound base URL is required when outbound is enabled');
      return;
    }
    try {
      const body = {
        code: intEditCode,
        name: intEditName,
        active: intEditActive,
        outboundEnabled: !!intEditOutboundEnabled,
        outboundBaseUrl: intEditOutboundBaseUrl.trim() || null,
      };
      // Only send the secret when the admin typed a new value, so
      // "leave field empty" never wipes the existing one.
      if (intEditOutboundSecret.trim()) body.outboundSecret = intEditOutboundSecret;
      await api.put(`${INT_BASE}/${selInt.id}`, body);
      toast.success('Integration updated'); await loadIntegrations();
      setSelInt(prev => ({
        ...prev,
        code: intEditCode,
        name: intEditName,
        active: intEditActive,
        outboundEnabled: !!intEditOutboundEnabled,
        outboundBaseUrl: intEditOutboundBaseUrl.trim() || null,
      }));
      setIntEditOutboundSecret('');
    } catch (e) { toast.error(e.message); }
  };

  const updateIntMargins = async () => {
    if (!selInt) return;
    const pn = v => (v === '' || v == null ? null : Number(v));
    const body = {};
    for (const f of MARGIN_FIELDS) body[f.key] = pn(intMargins[f.key]);
    try {
      await api.put(`${INT_BASE}/${selInt.id}/margins`, body);
      toast.success('Integration margins updated');
    } catch (e) { toast.error(e.message); }
  };

  const updateIntLambdas = async () => {
    if (!selInt) return;
    const pn = v => (v === '' || v == null ? null : Number(v));
    const body = {};
    for (const f of LAMBDA_FIELDS) body[f.key] = pn(intLambdas[f.key]);
    try {
      await api.put(`${INT_BASE}/${selInt.id}/lambdas`, body);
      toast.success('Integration lambdas updated');
    } catch (e) { toast.error(e.message); }
  };

  const fetchCountries = async (force = false) => {
    if (countriesFetched && !force) return;
    try { const d = await api.get('/v1/country/'); setCountries(Array.isArray(d) ? d : []); setCountriesFetched(true); } catch {}
  };
  const fetchLeagues = async (force = false) => {
    if (leaguesFetched && !force) return;
    try { const d = await api.get('/v1/league/'); setLeagues(Array.isArray(d) ? d : []); setLeaguesFetched(true); } catch {}
  };
  const fetchClubs = async (force = false) => {
    if (clubsFetched && !force) return;
    try { const d = await api.get('/v1/club/'); setClubs(Array.isArray(d) ? d : []); setClubsFetched(true); } catch {}
  };

  const updateLambda = async () => {
    const pn = v => (v === '' || v == null ? null : Number(v));
    const body = {};
    for (const f of LAMBDA_FIELDS) body[f.key] = pn(lambda[f.key]);
    try {
      const r = await api.put('/v1/lambda-config/', body);
      toast.success('Lambda updated');
      if (r) setLambda(Object.fromEntries(LAMBDA_FIELDS.map(f => [f.key, r[f.key] ?? ''])));
    } catch (e) { toast.error(e.message); }
  };

  const updateMargins = async () => {
    const body = {};
    for (const f of MARGIN_FIELDS) { const v = margins[f.key]; body[f.key] = (v === '' || v == null) ? null : Number(v); }
    try {
      const r = await api.put(`/v1/default-margins/${marginsId}`, body);
      toast.success('Margins updated'); const { id, ...rest } = r; setMarginsId(id); setMargins(rest);
    } catch (e) { toast.error(e.message); }
  };

  // Backend auto-generates `code` from `name` — we no longer send `code`.
  const createCountry = async (name) => {
    try {
      const r = await api.post('/v1/country/', { name });
      toast.success(`Country “${r?.name || name}” created (code: ${r?.code || '—'})`);
      if (r?.id != null) {
        setCountries(prev => [...prev, r]);
        setSelectedCountryId(r.id);
        return { value: r.id, label: `${r.name} [${r.code}]` };
      }
      await fetchCountries(true);
    } catch (e) { toast.error(e.message); }
  };

  const createLeague = async (name) => {
    if (!leagueCountryId) { toast.error('Select a country before creating a league'); return; }
    const country = countries.find(c => c.id === leagueCountryId);
    try {
      const r = await api.post('/v1/league/', { name, countryName: country?.name });
      toast.success(`League “${r?.name || name}” created (code: ${r?.code || '—'})`);
      if (r?.id != null) {
        setLeagues(prev => [...prev, r]);
        setSelectedLeagueId(r.id);
        return { value: r.id, label: `${r.name} [${r.code}]` };
      }
      await fetchLeagues(true);
    } catch (e) { toast.error(e.message); }
  };

  const createClub = async (name) => {
    try {
      const r = await api.post('/v1/club/', { name });
      toast.success(`Club “${r?.name || name}” created (code: ${r?.code || '—'})`);
      if (r?.id != null) {
        setClubs(prev => [...prev, r]);
        setSelectedClubId(r.id);
        return { value: r.id, label: `${r.name} [${r.code}]` };
      }
      await fetchClubs(true);
    } catch (e) { toast.error(e.message); }
  };

  const deleteEntity = async (entity, option, listSetter, selSetter, currentSel) => {
    if (!window.confirm(`Delete ${entity} “${option.label}”? This is a soft-delete; the name/code can be reused immediately.`)) return;
    try {
      await api.del(`/v1/${entity}/${option.value}`);
      toast.success(`${entity[0].toUpperCase()}${entity.slice(1)} deleted`);
      listSetter(prev => prev.filter(x => x.id !== option.value));
      if (currentSel === option.value) selSetter('');
    } catch (e) {
      // 404 → already gone; treat as success per FRONTEND_CLUBS_CRUD_AND_SOFT_DELETE.md.
      if (/404/.test(e.message)) {
        listSetter(prev => prev.filter(x => x.id !== option.value));
        if (currentSel === option.value) selSetter('');
      } else {
        toast.error(e.message);
      }
    }
  };

  return (
    <div className={p.page} style={{ display: 'flex', gap: 32 }}>
      {/* Sidebar */}
      <div style={{ width: 220, flexShrink: 0, position: 'sticky', top: 92, alignSelf: 'flex-start' }}>
        <div style={{ fontSize: '0.68rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.8px', color: 'var(--text-muted)', marginBottom: 12 }}>Settings</div>
        {SECTIONS.map(sec => (
          <React.Fragment key={sec.key}>
            <button onClick={() => setActiveSection(sec.key)} style={{
              display: 'flex', alignItems: 'center', gap: 10, width: '100%', padding: '10px 12px', borderRadius: 8,
              background: activeSection === sec.key ? 'var(--bg-active)' : 'none', border: 'none',
              color: activeSection === sec.key ? 'var(--accent)' : 'var(--text-secondary)',
              fontSize: '0.85rem', fontWeight: 500, cursor: 'pointer', textAlign: 'left', transition: 'all 0.15s', marginBottom: 2,
            }}>
              <span>{sec.icon}</span> {sec.label}
            </button>

            {/* Submenu — render only for the "imports" parent when it is active. */}
            {sec.key === 'imports' && activeSection === 'imports' && (
              <div style={{ marginLeft: 18, borderLeft: '1px solid var(--border)', paddingLeft: 6, marginBottom: 4 }}>
                {IMPORT_SUBSECTIONS.map(sub => (
                  <button key={sub.key} onClick={() => setActiveImport(sub.key)} style={{
                    display: 'flex', alignItems: 'center', gap: 8, width: '100%', padding: '7px 10px', borderRadius: 6,
                    background: activeImport === sub.key ? 'var(--bg-active)' : 'none', border: 'none',
                    color: activeImport === sub.key ? 'var(--accent)' : 'var(--text-secondary)',
                    fontSize: '0.78rem', fontWeight: 500, cursor: 'pointer', textAlign: 'left', transition: 'all 0.15s', marginBottom: 2,
                  }}>
                    <span>{sub.icon}</span> {sub.label}
                  </button>
                ))}
              </div>
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Content */}
      <div style={{ flex: 1, maxWidth: 800 }}>
        <div className={p.pageHeader}>
          <h1 className={p.pageTitle}>Settings</h1>
          <p className={p.pageSubtitle}>Configure margins, lambda values, and create entities</p>
        </div>

        {activeSection === 'general' && (
          <div className={p.sectionCard}>
            <div className={p.sectionCardHeader}><h3 className={p.sectionCardTitle}>General</h3></div>
            <div className={p.sectionCardBody}>
              <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Application settings and preferences. More options coming soon.</p>
            </div>
          </div>
        )}

        {activeSection === 'notifications' && <NotificationsSection
          api={api} toast={toast}
          notifTypes={notifTypes} notifTargetTypes={notifTargetTypes}
          allNotifs={allNotifs} notifSearch={notifSearch} setNotifSearch={setNotifSearch}
          nTitle={nTitle} setNTitle={setNTitle} nBody={nBody} setNBody={setNBody}
          nTypeId={nTypeId} setNTypeId={setNTypeId} nTargetTypeId={nTargetTypeId} setNTargetTypeId={setNTargetTypeId}
          nTargetUserId={nTargetUserId} setNTargetUserId={setNTargetUserId}
          nPriority={nPriority} setNPriority={setNPriority}
          nActionUrl={nActionUrl} setNActionUrl={setNActionUrl}
          nScheduledAt={nScheduledAt} setNScheduledAt={setNScheduledAt}
          nScheduledTz={nScheduledTz} setNScheduledTz={setNScheduledTz}
          userList={userList} fetchUsers={fetchUsers}
          loadNotifications={loadNotifications} loadNotifLookups={loadNotifLookups}
          handleCreateNotification={handleCreateNotification}
          handleDeleteNotification={handleDeleteNotification}
        />}

        {activeSection === 'integrations' && (
          <>
            {/* Create integration */}
            <div className={p.sectionCard}>
              <div className={p.sectionCardHeader}><h3 className={p.sectionCardTitle}>Create Integration</h3></div>
              <div className={p.sectionCardBody}>
                <div className={p.inlineFields}>
                  <div className={p.fieldGroup}><label className={p.fieldLabel}>Code *</label><input className={p.fieldInput} type="text" value={intCode} onChange={e => setIntCode(e.target.value)} placeholder="e.g. betway" /></div>
                  <div className={p.fieldGroup}><label className={p.fieldLabel}>Name</label><input className={p.fieldInput} type="text" value={intName} onChange={e => setIntName(e.target.value)} placeholder="e.g. Betway" /></div>
                </div>
                <div className={p.inlineFields} style={{ marginTop: 12 }}>
                  <div className={p.fieldGroup}>
                    <label className={p.fieldLabel}>Outbound webhooks</label>
                    <div onClick={() => setIntOutboundEnabled(v => !v)} style={{ width: 40, height: 22, borderRadius: 11, background: intOutboundEnabled ? '#73c991' : 'var(--border-color)', position: 'relative', cursor: 'pointer', transition: 'background 0.2s', marginTop: 6 }}>
                      <div style={{ width: 18, height: 18, borderRadius: '50%', background: '#fff', position: 'absolute', top: 2, left: intOutboundEnabled ? 20 : 2, transition: 'left 0.15s', boxShadow: '0 1px 2px rgba(0,0,0,0.2)' }} />
                    </div>
                  </div>
                  <div className={p.fieldGroup} style={{ flex: 2 }}>
                    <label className={p.fieldLabel}>Outbound base URL</label>
                    <input className={p.fieldInput} type="text" value={intOutboundBaseUrl} onChange={e => setIntOutboundBaseUrl(e.target.value)} placeholder="https://partner.example.com" />
                  </div>
                  <div className={p.fieldGroup} style={{ flex: 2 }}>
                    <label className={p.fieldLabel}>Outbound secret (HMAC)</label>
                    <input className={p.fieldInput} type="password" value={intOutboundSecret} onChange={e => setIntOutboundSecret(e.target.value)} placeholder="shared secret" />
                  </div>
                  <button className={`${p.btnPrimary} ${p.btnSmall}`} onClick={createIntegration}>Create</button>
                </div>
                <p style={{ color: 'var(--text-muted)', fontSize: '0.75rem', marginTop: 8 }}>
                  When outbound webhooks are enabled, Clasico will push manual-market events (create / settle / void / bet placed) to <code>{'{baseUrl}'}</code> signed with the secret.
                </p>
              </div>
            </div>

            {/* Integration list */}
            <div className={p.sectionCard}>
              <div className={p.sectionCardHeader}><h3 className={p.sectionCardTitle}>Integrations</h3></div>
              <div className={p.sectionCardBody}>
                {intList.length === 0 ? (
                  <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>No integrations yet. Create one above.</p>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                    {intList.map(int => (
                      <div key={int.id} onClick={() => selectIntegration(int)}
                        style={{
                          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                          padding: '10px 14px', borderRadius: 8, cursor: 'pointer', transition: 'all 0.15s',
                          background: selInt?.id === int.id ? 'var(--bg-active)' : 'var(--bg-primary)',
                          border: `1px solid ${selInt?.id === int.id ? 'var(--accent)' : 'var(--border-color)'}`,
                        }}>
                        <div>
                          <div style={{ fontSize: '0.88rem', fontWeight: 600, color: 'var(--text-primary)' }}>{int.name || int.code}</div>
                          <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>Code: {int.code} · ID: {int.id}</div>
                        </div>
                        <span className={`${p.badge} ${int.active ? p.badgeFinished : p.badgeDraft}`}>
                          {int.active ? 'Active' : 'Inactive'}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Selected integration detail */}
            {selInt && (
              <>
                <div className={p.sectionCard}>
                  <div className={p.sectionCardHeader}><h3 className={p.sectionCardTitle}>Edit — {selInt.name || selInt.code}</h3></div>
                  <div className={p.sectionCardBody}>
                    <div className={p.inlineFields}>
                      <div className={p.fieldGroup}><label className={p.fieldLabel}>Code</label><input className={p.fieldInput} type="text" value={intEditCode} onChange={e => setIntEditCode(e.target.value)} /></div>
                      <div className={p.fieldGroup}><label className={p.fieldLabel}>Name</label><input className={p.fieldInput} type="text" value={intEditName} onChange={e => setIntEditName(e.target.value)} /></div>
                      <div className={p.fieldGroup}>
                        <label className={p.fieldLabel}>Active</label>
                        <div onClick={() => setIntEditActive(v => !v)} style={{ width: 40, height: 22, borderRadius: 11, background: intEditActive ? '#73c991' : 'var(--border-color)', position: 'relative', cursor: 'pointer', transition: 'background 0.2s', marginTop: 6 }}>
                          <div style={{ width: 18, height: 18, borderRadius: '50%', background: '#fff', position: 'absolute', top: 2, left: intEditActive ? 20 : 2, transition: 'left 0.15s', boxShadow: '0 1px 2px rgba(0,0,0,0.2)' }} />
                        </div>
                      </div>
                    </div>
                    <div className={p.inlineFields} style={{ marginTop: 12 }}>
                      <div className={p.fieldGroup}>
                        <label className={p.fieldLabel}>Outbound webhooks</label>
                        <div onClick={() => setIntEditOutboundEnabled(v => !v)} style={{ width: 40, height: 22, borderRadius: 11, background: intEditOutboundEnabled ? '#73c991' : 'var(--border-color)', position: 'relative', cursor: 'pointer', transition: 'background 0.2s', marginTop: 6 }}>
                          <div style={{ width: 18, height: 18, borderRadius: '50%', background: '#fff', position: 'absolute', top: 2, left: intEditOutboundEnabled ? 20 : 2, transition: 'left 0.15s', boxShadow: '0 1px 2px rgba(0,0,0,0.2)' }} />
                        </div>
                      </div>
                      <div className={p.fieldGroup} style={{ flex: 2 }}>
                        <label className={p.fieldLabel}>Outbound base URL</label>
                        <input className={p.fieldInput} type="text" value={intEditOutboundBaseUrl} onChange={e => setIntEditOutboundBaseUrl(e.target.value)} placeholder="https://partner.example.com" />
                      </div>
                      <div className={p.fieldGroup} style={{ flex: 2 }}>
                        <label className={p.fieldLabel}>Outbound secret (leave empty to keep current)</label>
                        <input className={p.fieldInput} type="password" value={intEditOutboundSecret} onChange={e => setIntEditOutboundSecret(e.target.value)} placeholder="••••••••" autoComplete="new-password" />
                      </div>
                      <button className={`${p.btnPrimary} ${p.btnSmall}`} onClick={updateIntegration}>Update</button>
                    </div>
                  </div>
                </div>

                <div className={p.sectionCard}>
                  <div className={p.sectionCardHeader}><h3 className={p.sectionCardTitle}>Default Lambdas — {selInt.name || selInt.code}</h3></div>
                  <div className={p.sectionCardBody}>
                    <div className={p.quotaGrid}>
                      {LAMBDA_FIELDS.map(f => (
                        <div key={f.key} className={p.quotaField}>
                          <label className={p.quotaLabel}>{f.label}</label>
                          <input className={p.quotaInput} type="text" value={intLambdas[f.key] ?? ''} onChange={e => setIntLambdas(prev => ({ ...prev, [f.key]: e.target.value }))} />
                        </div>
                      ))}
                    </div>
                    <div style={{ marginTop: 16 }}><button className={p.btnPrimary} onClick={updateIntLambdas}>Update Lambdas</button></div>
                  </div>
                </div>

                <div className={p.sectionCard}>
                  <div className={p.sectionCardHeader}><h3 className={p.sectionCardTitle}>Default Margins — {selInt.name || selInt.code}</h3></div>
                  <div className={p.sectionCardBody}>
                    <div className={p.quotaGrid}>
                      {MARGIN_FIELDS.map(f => (
                        <div key={f.key} className={p.quotaField}>
                          <label className={p.quotaLabel}>{f.label}</label>
                          <input className={p.quotaInput} type="text" value={intMargins[f.key] ?? ''} onChange={e => setIntMargins(prev => ({ ...prev, [f.key]: e.target.value }))} />
                        </div>
                      ))}
                    </div>
                    <div style={{ marginTop: 16 }}><button className={p.btnPrimary} onClick={updateIntMargins}>Update Margins</button></div>
                  </div>
                </div>
              </>
            )}
          </>
        )}

        {activeSection === 'lambda' && (
          <div className={p.sectionCard}>
            <div className={p.sectionCardHeader}><h3 className={p.sectionCardTitle}>Lambda Config</h3></div>
            <div className={p.sectionCardBody}>
              <div className={p.quotaGrid}>
                {LAMBDA_FIELDS.map(f => (
                  <div key={f.key} className={p.quotaField}>
                    <label className={p.quotaLabel}>{f.label}</label>
                    <input className={p.quotaInput} type="text" value={lambda[f.key] ?? ''} onChange={e => setLambda(prev => ({ ...prev, [f.key]: e.target.value }))} />
                  </div>
                ))}
              </div>
              <div style={{ marginTop: 16 }}><button className={p.btnPrimary} onClick={updateLambda}>Update Lambda</button></div>
            </div>
          </div>
        )}

        {activeSection === 'margins' && (
          <div className={p.sectionCard}>
            <div className={p.sectionCardHeader}><h3 className={p.sectionCardTitle}>Default Margins</h3></div>
            <div className={p.sectionCardBody}>
              <div className={p.quotaGrid}>
                {MARGIN_FIELDS.map(f => (
                  <div key={f.key} className={p.quotaField}>
                    <label className={p.quotaLabel}>{f.label}</label>
                    <input className={p.quotaInput} type="text" value={margins[f.key] ?? ''} onChange={e => setMargins(prev => ({ ...prev, [f.key]: e.target.value }))} />
                  </div>
                ))}
              </div>
              <div style={{ marginTop: 16 }}><button className={p.btnPrimary} onClick={updateMargins}>Update Margins</button></div>
            </div>
          </div>
        )}

        {activeSection === 'entities' && (
          <>
            <div className={p.sectionCard}>
              <div className={p.sectionCardHeader}><h3 className={p.sectionCardTitle}>Countries</h3></div>
              <div className={p.sectionCardBody}>
                <p style={{ color: 'var(--text-muted)', fontSize: '0.78rem', marginTop: 0 }}>
                  Search to filter. Type a new name and press <kbd>Enter</kbd> (or click <em>Create “…”</em>) to add it.
                  Backend auto-generates the <code>code</code>.
                </p>
                <div className={p.inlineFields}>
                  <div className={p.fieldGroup}>
                    <label className={p.fieldLabel}>Country</label>
                    <SearchSelect
                      width="320px"
                      placeholder="Search or type to create…"
                      searchPlaceholder="Type country name…"
                      options={countries.map(c => ({ value: c.id, label: `${c.name} [${c.code}]` }))}
                      value={selectedCountryId}
                      onChange={setSelectedCountryId}
                      onOpen={() => fetchCountries()}
                      onCreate={createCountry}
                      onDelete={(opt) => deleteEntity('country', opt, setCountries, setSelectedCountryId, selectedCountryId)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className={p.sectionCard}>
              <div className={p.sectionCardHeader}><h3 className={p.sectionCardTitle}>Leagues</h3></div>
              <div className={p.sectionCardBody}>
                <p style={{ color: 'var(--text-muted)', fontSize: '0.78rem', marginTop: 0 }}>
                  Pick a country first, then search or press <kbd>Enter</kbd> on a new league name to create it.
                </p>
                <div className={p.inlineFields}>
                  <div className={p.fieldGroup}>
                    <label className={p.fieldLabel}>Country (for new leagues)</label>
                    <SearchSelect
                      width="260px"
                      placeholder="Country…"
                      options={countries.map(c => ({ value: c.id, label: `${c.name} [${c.code}]` }))}
                      value={leagueCountryId}
                      onChange={setLeagueCountryId}
                      onOpen={() => fetchCountries()}
                    />
                  </div>
                  <div className={p.fieldGroup}>
                    <label className={p.fieldLabel}>League</label>
                    <SearchSelect
                      width="320px"
                      placeholder="Search or type to create…"
                      searchPlaceholder="Type league name…"
                      options={leagues.map(l => ({ value: l.id, label: `${l.name} [${l.code}]` }))}
                      value={selectedLeagueId}
                      onChange={setSelectedLeagueId}
                      onOpen={() => fetchLeagues()}
                      onCreate={createLeague}
                      onDelete={(opt) => deleteEntity('league', opt, setLeagues, setSelectedLeagueId, selectedLeagueId)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className={p.sectionCard}>
              <div className={p.sectionCardHeader}><h3 className={p.sectionCardTitle}>Clubs</h3></div>
              <div className={p.sectionCardBody}>
                <p style={{ color: 'var(--text-muted)', fontSize: '0.78rem', marginTop: 0 }}>
                  Search to filter. Type a new name and press <kbd>Enter</kbd> to create.
                </p>
                <div className={p.inlineFields}>
                  <div className={p.fieldGroup}>
                    <label className={p.fieldLabel}>Club</label>
                    <SearchSelect
                      width="360px"
                      placeholder="Search or type to create…"
                      searchPlaceholder="Type club name…"
                      options={clubs.map(c => ({ value: c.id, label: `${c.name} [${c.code}]` }))}
                      value={selectedClubId}
                      onChange={setSelectedClubId}
                      onOpen={() => fetchClubs()}
                      onCreate={createClub}
                      onDelete={(opt) => deleteEntity('club', opt, setClubs, setSelectedClubId, selectedClubId)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {activeSection === 'imports' && (
          <>
            {activeImport === 'clubs' && <ClubsImportSection api={api} toast={toast} />}
          </>
        )}

        {activeSection === 'catalog' && (
          <MarketsCatalogSection token={token} toast={toast} />
        )}

        {activeSection === 'translation' && (
          <div style={{ margin: '-24px -24px -72px' }}>
            <Translate />
          </div>
        )}
      </div>
    </div>
  );
}

/* ── Notifications Section (extracted for readability) ── */
const TZ_OPTIONS = ['+00:00', '+01:00', '+02:00', '+03:00', '-05:00', '-08:00'];
const PRIORITIES = ['low', 'normal', 'high', 'urgent'];
const PRIORITY_COLORS = { low: 'var(--text-muted)', normal: 'var(--text-secondary)', high: '#d4a052', urgent: '#e06c75' };

function timeAgo(iso) {
  if (!iso) return '';
  const d = (Date.now() - new Date(iso).getTime()) / 1000;
  if (d < 60) return 'just now';
  if (d < 3600) return `${Math.floor(d / 60)}m ago`;
  if (d < 86400) return `${Math.floor(d / 3600)}h ago`;
  return new Date(iso).toLocaleDateString();
}

function NotificationsSection({
  api, toast,
  notifTypes, notifTargetTypes, allNotifs, notifSearch, setNotifSearch,
  nTitle, setNTitle, nBody, setNBody, nTypeId, setNTypeId,
  nTargetTypeId, setNTargetTypeId, nTargetUserId, setNTargetUserId,
  nPriority, setNPriority, nActionUrl, setNActionUrl,
  nScheduledAt, setNScheduledAt, nScheduledTz, setNScheduledTz,
  userList, fetchUsers,
  loadNotifications, loadNotifLookups,
  handleCreateNotification, handleDeleteNotification,
}) {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    if (!loaded) { loadNotifLookups(); loadNotifications(); fetchUsers(); setLoaded(true); }
  }, [loaded, loadNotifLookups, loadNotifications, fetchUsers]);

  const targetType = notifTargetTypes.find(t => t.id === Number(nTargetTypeId));
  const showUserPicker = targetType?.code === 'user';
  const filtered = allNotifs.filter(n => {
    if (!notifSearch) return true;
    const q = notifSearch.toLowerCase();
    return (n.title || '').toLowerCase().includes(q) || (n.body || '').toLowerCase().includes(q);
  });

  return (
    <>
      {/* Create notification */}
      <div className={p.sectionCard}>
        <div className={p.sectionCardHeader}>
          <h3 className={p.sectionCardTitle}>Create Notification</h3>
          <span style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>Backend also creates notifications automatically</span>
        </div>
        <div className={p.sectionCardBody}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {/* Row 1: Title + Priority */}
            <div className={p.inlineFields}>
              <div className={p.fieldGroup} style={{ flex: 2 }}>
                <label className={p.fieldLabel}>Title *</label>
                <input className={p.fieldInput} type="text" value={nTitle} onChange={e => setNTitle(e.target.value)} placeholder="Notification title" />
              </div>
              <div className={p.fieldGroup}>
                <label className={p.fieldLabel}>Priority</label>
                <select className={p.fieldInput} value={nPriority} onChange={e => setNPriority(e.target.value)} style={{ padding: '7px 10px' }}>
                  {PRIORITIES.map(pr => <option key={pr} value={pr}>{pr}</option>)}
                </select>
              </div>
            </div>

            {/* Row 2: Body */}
            <div className={p.fieldGroup}>
              <label className={p.fieldLabel}>Body</label>
              <textarea className={p.fieldInput} rows={3} value={nBody} onChange={e => setNBody(e.target.value)} placeholder="Optional message body…" style={{ resize: 'vertical', fontFamily: 'inherit' }} />
            </div>

            {/* Row 3: Type + Target */}
            <div className={p.inlineFields}>
              <div className={p.fieldGroup}>
                <label className={p.fieldLabel}>Type *</label>
                <select className={p.fieldInput} value={nTypeId} onChange={e => setNTypeId(e.target.value)} style={{ padding: '7px 10px' }}>
                  <option value="">— select —</option>
                  {notifTypes.map(t => <option key={t.id} value={t.id}>{t.label || t.code}</option>)}
                </select>
              </div>
              <div className={p.fieldGroup}>
                <label className={p.fieldLabel}>Target *</label>
                <select className={p.fieldInput} value={nTargetTypeId} onChange={e => setNTargetTypeId(e.target.value)} style={{ padding: '7px 10px' }}>
                  <option value="">— select —</option>
                  {notifTargetTypes.map(t => <option key={t.id} value={t.id}>{t.code}</option>)}
                </select>
              </div>
              {showUserPicker && (
                <div className={p.fieldGroup}>
                  <label className={p.fieldLabel}>User *</label>
                  <select className={p.fieldInput} value={nTargetUserId} onChange={e => setNTargetUserId(e.target.value)} style={{ padding: '7px 10px' }}>
                    <option value="">— select user —</option>
                    {userList.map(u => <option key={u.id} value={u.id}>{u.username} ({u.name})</option>)}
                  </select>
                </div>
              )}
            </div>

            {/* Row 4: Action URL + Schedule */}
            <div className={p.inlineFields}>
              <div className={p.fieldGroup} style={{ flex: 2 }}>
                <label className={p.fieldLabel}>Action URL</label>
                <input className={p.fieldInput} type="text" value={nActionUrl} onChange={e => setNActionUrl(e.target.value)} placeholder="/pending or /clasico/5" />
              </div>
              <div className={p.fieldGroup}>
                <label className={p.fieldLabel}>Schedule (optional)</label>
                <div style={{ display: 'flex', gap: 4 }}>
                  <input className={p.fieldInput} type="datetime-local" value={nScheduledAt} onChange={e => setNScheduledAt(e.target.value)} style={{ flex: 1, fontSize: '0.78rem' }} />
                  <select className={p.fieldInput} value={nScheduledTz} onChange={e => setNScheduledTz(e.target.value)} style={{ width: 90, fontSize: '0.72rem', padding: '5px 4px' }}>
                    {TZ_OPTIONS.map(tz => <option key={tz} value={tz}>UTC{tz}</option>)}
                  </select>
                </div>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <button className={p.btnPrimary} onClick={handleCreateNotification} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <FiSend size={13} /> Send Notification
              </button>
              {nScheduledAt && <span style={{ fontSize: '0.72rem', color: '#d4a052' }}>⏰ Will be scheduled, not sent immediately</span>}
            </div>
          </div>
        </div>
      </div>

      {/* Notification list */}
      <div className={p.sectionCard}>
        <div className={p.sectionCardHeader}>
          <h3 className={p.sectionCardTitle}>All Notifications ({allNotifs.length})</h3>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{ position: 'relative' }}>
              <FiSearch style={{ position: 'absolute', left: 8, top: 9, color: 'var(--text-muted)', fontSize: '0.8rem' }} />
              <input className={p.fieldInput} type="text" value={notifSearch} onChange={e => setNotifSearch(e.target.value)} placeholder="Search…" style={{ paddingLeft: 28, width: 180, fontSize: '0.78rem' }} />
            </div>
            <button className={`${p.btnOutline} ${p.btnSmall}`} onClick={loadNotifications}>Refresh</button>
          </div>
        </div>
        <div className={p.sectionCardBody}>
          {filtered.length === 0 ? (
            <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', textAlign: 'center', padding: '24px 0' }}>
              {allNotifs.length === 0 ? 'No notifications created yet.' : 'No matches for search.'}
            </p>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 420, overflowY: 'auto', paddingRight: 6 }}>
              {filtered.map(n => (
                <div key={n.id} style={{
                  display: 'flex', alignItems: 'flex-start', gap: 12, padding: '12px 14px', borderRadius: 8,
                  background: 'var(--bg-primary)', border: '1px solid var(--border-color)', transition: 'all 0.15s',
                }}>
                  {/* Priority indicator */}
                  <div style={{ width: 4, minHeight: 40, borderRadius: 2, background: PRIORITY_COLORS[n.priority] || PRIORITY_COLORS.normal, flexShrink: 0, marginTop: 2 }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 3 }}>
                      <span style={{ fontSize: '0.88rem', fontWeight: 600, color: 'var(--text-primary)' }}>{n.title}</span>
                      <span className={`${p.badge} ${n.isDispatched ? p.badgeFinished : p.badgePending}`} style={{ fontSize: '0.58rem' }}>
                        {n.isDispatched ? 'dispatched' : n.scheduledAt ? 'scheduled' : 'pending'}
                      </span>
                      <span className={`${p.badge} ${p.badgeDraft}`} style={{ fontSize: '0.58rem' }}>{n.targetTypeCode || 'all'}</span>
                      <span style={{ fontSize: '0.65rem', color: PRIORITY_COLORS[n.priority] || 'var(--text-muted)', fontWeight: 600, textTransform: 'uppercase' }}>{n.priority}</span>
                    </div>
                    {n.body && <div style={{ fontSize: '0.78rem', color: 'var(--text-secondary)', lineHeight: 1.4, marginBottom: 4, whiteSpace: 'pre-wrap', maxHeight: 60, overflow: 'hidden' }}>{n.body}</div>}
                    <div style={{ display: 'flex', gap: 12, fontSize: '0.7rem', color: 'var(--text-muted)', flexWrap: 'wrap' }}>
                      <span>Type: {n.notificationTypeCode || '—'}</span>
                      {n.targetUserUsername && <span>To: {n.targetUserUsername}</span>}
                      {n.scheduledAt && <span>Scheduled: {new Date(n.scheduledAt).toLocaleString()}</span>}
                      <span>{timeAgo(n.created)}</span>
                      {n.actionUrl && <span>→ {n.actionUrl}</span>}
                    </div>
                  </div>
                  <button onClick={() => handleDeleteNotification(n.id)} style={{ background: 'none', border: '1px solid rgba(224,108,117,0.2)', borderRadius: 6, padding: '4px 8px', cursor: 'pointer', color: '#e06c75', fontSize: '0.72rem', display: 'flex', alignItems: 'center', gap: 3, flexShrink: 0 }} title="Delete notification">
                    <FiTrash2 size={11} /> Delete
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

/* ── Imports: Clubs / Leagues / Countries (XLSX) ── */
function ClubsImportSection({ api, toast }) {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [result, setResult] = useState(null);
  const [showErrors, setShowErrors] = useState(false);

  const onFileChange = (e) => {
    const f = e.target.files?.[0] || null;
    setResult(null);
    if (f && !f.name.toLowerCase().endsWith('.xlsx')) {
      toast.error('Only .xlsx files are accepted');
      e.target.value = '';
      setFile(null);
      return;
    }
    setFile(f);
  };

  const onUpload = async () => {
    if (!file) { toast.error('Please choose an .xlsx file first'); return; }
    setUploading(true);
    setResult(null);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const summary = await api.postForm('/v1/clubs-import/xlsx', fd);
      setResult(summary);
      const created = (summary?.countriesCreated || 0) + (summary?.leaguesCreated || 0) + (summary?.clubsCreated || 0);
      toast.success(`Import complete — ${created} new entit${created === 1 ? 'y' : 'ies'} created`);
    } catch (e) {
      toast.error(e.message || 'Import failed');
    } finally {
      setUploading(false);
    }
  };

  const stat = (label, value, color) => (
    <div style={{
      display: 'flex', flexDirection: 'column', gap: 4, padding: '10px 12px',
      background: 'var(--bg-secondary)', borderRadius: 8, border: '1px solid var(--border)', minWidth: 120,
    }}>
      <span style={{ fontSize: '0.7rem', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{label}</span>
      <span style={{ fontSize: '1.1rem', fontWeight: 600, color: color || 'var(--text-primary)' }}>{value ?? 0}</span>
    </div>
  );

  return (
    <div className={p.sectionCard}>
      <div className={p.sectionCardHeader}>
        <h3 className={p.sectionCardTitle}>Import Clubs / Leagues / Countries</h3>
        <span style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>XLSX with columns: Country, Leagues, Teams</span>
      </div>
      <div className={p.sectionCardBody}>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.82rem', marginTop: 0 }}>
          Upload an .xlsx file. The first sheet is read; the first row must contain the headers
          <code style={{ margin: '0 4px' }}>Country</code>,
          <code style={{ margin: '0 4px' }}>Leagues</code>,
          <code style={{ margin: '0 4px' }}>Teams</code>.
          Existing entities (matched by name) are skipped — the operation is idempotent.
        </p>

        <div className={p.inlineFields} style={{ alignItems: 'flex-end' }}>
          <div className={p.fieldGroup} style={{ flex: 1 }}>
            <label className={p.fieldLabel}>File</label>
            <input
              className={p.fieldInput}
              type="file"
              accept=".xlsx"
              onChange={onFileChange}
              disabled={uploading}
            />
          </div>
          <button
            className={`${p.btnPrimary} ${p.btnSmall}`}
            onClick={onUpload}
            disabled={!file || uploading}
          >
            {uploading ? 'Uploading…' : 'Upload'}
          </button>
        </div>

        {result && (
          <div style={{ marginTop: 18, display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)' }}>
              Processed <strong style={{ color: 'var(--text-primary)' }}>{result.rowsProcessed ?? 0}</strong> rows
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
              {stat('Countries created', result.countriesCreated, 'var(--accent)')}
              {stat('Leagues created', result.leaguesCreated, 'var(--accent)')}
              {stat('Clubs created', result.clubsCreated, 'var(--accent)')}
              {stat('Countries skipped', result.countriesSkipped)}
              {stat('Leagues skipped', result.leaguesSkipped)}
              {stat('Clubs skipped', result.clubsSkipped)}
            </div>
            {Array.isArray(result.errors) && result.errors.length > 0 && (
              <div style={{ border: '1px solid #e06c75', borderRadius: 8, background: 'rgba(224,108,117,0.08)', padding: 12 }}>
                <button
                  onClick={() => setShowErrors(s => !s)}
                  style={{ background: 'none', border: 'none', color: '#e06c75', fontWeight: 600, cursor: 'pointer', padding: 0, fontSize: '0.85rem' }}
                >
                  {showErrors ? '▼' : '▶'} {result.errors.length} error{result.errors.length === 1 ? '' : 's'}
                </button>
                {showErrors && (
                  <ul style={{ margin: '8px 0 0', paddingLeft: 20, color: '#e06c75', fontSize: '0.8rem', maxHeight: 240, overflow: 'auto' }}>
                    {result.errors.map((err, i) => <li key={i} style={{ marginBottom: 4 }}>{err}</li>)}
                  </ul>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

/* ── Markets Catalog (Integrator Docs) Section ── */
function MarketsCatalogSection({ token, toast }) {
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);
  const [scope, setScope] = useState('all');
  const [downloading, setDownloading] = useState(false);
  const [jsonOpen, setJsonOpen] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/v1/markets-catalog/`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        if (mounted) setMeta({
          version: json.version,
          generatedAt: json.generatedAt,
          productName: json.productName,
          fictiveCount: json.sections?.find(s => s.scope === 'FICTIVE')?.markets?.length || 0,
          realCount: json.sections?.find(s => s.scope === 'REAL')?.markets?.length || 0,
          manualFields: json.manualMarkets?.fields?.length || 0,
        });
      } catch (e) {
        if (mounted) toast.error(`Failed to load catalog metadata: ${e.message}`);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, [toast]);

  const downloadXlsx = async () => {
    setDownloading(true);
    try {
      const url = `${API_BASE_URL}/v1/markets-catalog/export.xlsx?scope=${encodeURIComponent(scope)}`;
      const res = await fetch(url, {
        headers: { 'auth-token': token || '', 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
      });
      if (!res.ok) throw new Error(`Download failed (HTTP ${res.status})`);
      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = 'markets-catalog.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
      toast.success('Catalog downloaded');
    } catch (e) {
      toast.error(e.message || 'Download failed');
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className={p.sectionCard}>
      <div className={p.sectionCardHeader}>
        <h3 className={p.sectionCardTitle}>Markets Catalog (Integrator Docs)</h3>
      </div>
      <div className={p.sectionCardBody}>
        <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', lineHeight: 1.55, marginTop: 0 }}>
          The Markets Catalog is the public, machine-readable reference of every betting market our platform exposes.
          Share it with prospective integrators as a stable specification.
        </p>

        {loading ? (
          <div style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Loading catalog metadata…</div>
        ) : meta && (
          <div style={{
            display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12,
            margin: '14px 0 18px',
          }}>
            {[
              { label: 'Product', value: meta.productName },
              { label: 'Version', value: meta.version },
              { label: 'Last updated', value: meta.generatedAt ? new Date(meta.generatedAt).toLocaleString() : '—' },
              { label: 'Fictive markets', value: meta.fictiveCount },
              { label: 'Real markets', value: meta.realCount },
              { label: 'Manual fields', value: meta.manualFields },
            ].map(item => (
              <div key={item.label} style={{
                background: 'var(--bg-primary)', border: '1px solid var(--border-color)',
                borderRadius: 8, padding: '10px 12px',
              }}>
                <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.6px' }}>{item.label}</div>
                <div style={{ fontSize: '0.85rem', color: 'var(--text-primary)', fontWeight: 600, marginTop: 4 }}>{String(item.value)}</div>
              </div>
            ))}
          </div>
        )}

        <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap', marginTop: 14 }}>
          <label style={{ fontSize: '0.82rem', color: 'var(--text-secondary)' }}>
            Export scope:
            <select
              value={scope}
              onChange={(e) => setScope(e.target.value)}
              className={p.formSelect}
              style={{ marginLeft: 8, padding: '6px 28px 6px 10px', fontSize: '0.82rem' }}
            >
              <option value="all">All (fictive + real + manual)</option>
              <option value="fictive">Fictive only</option>
              <option value="real">Real only</option>
              <option value="manual">Manual only</option>
              <option value="fictive,real">Fictive + Real</option>
            </select>
          </label>
          <button
            className={p.btnPrimary}
            onClick={downloadXlsx}
            disabled={downloading}
          >
            <FiDownload /> {downloading ? 'Preparing…' : 'Download XLSX'}
          </button>

          <button
            type="button"
            className={p.btnDefault}
            onClick={() => setJsonOpen(true)}
          >
            <FiGrid /> Preview JSON workbook
          </button>

          <Link
            to="/integrations/markets-catalog"
            target="_blank"
            rel="noreferrer"
            className={p.btnOutline}
            style={{ textDecoration: 'none' }}
          >
            <FiExternalLink /> Open public docs page
          </Link>
        </div>

        <div style={{ marginTop: 16, fontSize: '0.74rem', color: 'var(--text-muted)' }}>
          Tip: the JSON catalog at <code>/api/v1/markets-catalog/</code> is public and does not require auth — share it freely.
          The XLSX export is admin-only and intended for out-of-band sharing.
        </div>
      </div>

      <Modal open={jsonOpen} onClose={() => setJsonOpen(false)} title="Markets Catalog — JSON Workbook" wide>
        <CatalogJsonViewer scope={scope} height="70vh" />
      </Modal>
    </div>
  );
}
